import { render, staticRenderFns } from "./QuemSomos.vue?vue&type=template&id=20a5a345&"
import script from "./QuemSomos.vue?vue&type=script&lang=js&"
export * from "./QuemSomos.vue?vue&type=script&lang=js&"
import style0 from "./QuemSomos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports